import { ChangeDetectorRef, effect, HostListener, inject, input, model, OnInit, output, viewChild } from "@angular/core";
import { Component } from '@angular/core';
import { MatTabChangeEvent, MatTabGroup } from "@angular/material/tabs";
import { login, LoginService } from "../../services/jkUser";
import { OpenWinLoadOption } from "../../services/jkInterface";
//import { orm } from "../../services/jkOrm";
import { PageService } from "../../services/page.service";
import { JkaboutComponent } from "../jkabout/jkabout.component";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { HttpClient } from "@angular/common/http";
import { OrmService } from "../../services/jkOrm";
import { JkBDbService } from "../../services/jkBdb";

/** 標籤顯示模式類型定義 */
export type LabelMode = 'static' | 'floating' | 'hidden' | 'outside';

/**
 * JkBaseComponent
 *
 * JK 服務框架中所有 UI 組件的基礎類。提供通用功能和屬性，確保所有衍生組件具有一致的行為和介面。
 * 實作了標籤管理、樣式控制、對話框功能等共用功能。
 *
 * @see jkbase.component.md 完整文檔
 */
@Component({
  selector: 'app-jkbase',
  //standalone: true,
  template: '',
  providers: [
    { provide: MatDialogRef, useValue: {} },
    //{ provide: MAT_MDC_DIALOG_DATA, useValue: {} } //
  ],
  imports: [],
})
/**
 * JK 基礎組件類
 * 所有 JK 組件的基礎類，提供共用功能和屬性
 */
export class JkBaseComponent implements OnInit {
  /** 標籤頁群組引用 */
  readonly masterTabGroup = viewChild.required<MatTabGroup>('masterTabGroup');

  /** 對話框服務 */
  public dialog: MatDialog = inject(MatDialog); // ModalController;

  /** 變更檢測器引用 */
  public cdr = inject(ChangeDetectorRef);

  /**
   * 處理主標籤頁變更事件
   * @param $event 標籤變更事件
   */
  onMasterTabChange($event: MatTabChangeEvent) {
  }

  /**
   * 初始化標籤頁群組
   * 設定標籤頁群組的動畫時間、延展和高度屬性
   */
  initTabGroup() {
    const masterTabGroup = this.masterTabGroup();
    if (masterTabGroup) {
      masterTabGroup.animationDuration = "0ms";
      masterTabGroup.stretchTabs = false;
      masterTabGroup.dynamicHeight = false;
    }
  }

  /** 組件類型識別 */
  comType: string = 'jkbase';
  /*
  _programId: string = '';
  get programId(): string {
    return this._programId.toLocaleLowerCase();
  }
  set programId(value: string) {
    this._programId = value.toLocaleLowerCase();
  }
    */
  /** 組件名稱 */
  readonly comName = input<string>('');
  /**
   * 取得當前選中的標籤頁索引
   * @returns 選中的標籤頁索引，若無標籤頁群組則返回 null
   */
  get masterTabGroupIndex(): number | null {
    const masterTabGroup = this.masterTabGroup();
    if (!masterTabGroup) return null;
    return masterTabGroup.selectedIndex;
  }

  /**
   * 設定當前選中的標籤頁索引
   * @param value 要選中的標籤頁索引
   */
  set masterTabGroupIndex(value: number) {
    const masterTabGroup = this.masterTabGroup();
    if (!masterTabGroup) return;
    masterTabGroup.selectedIndex = value!;
  }

  /** 組件準備就緒事件發射器 */
  readonly onReady = output<any>();

  /**
   * 視圖初始化後的處理
   * 發出組件準備就緒事件
   */
  ngAfterViewInit() {
    if (this.onReady) {
      this.onReady.emit(this);
    }
  }

  /** CSS display 屬性: "flex" 顯示左右 ｜ "block" 顯示上下 ｜ "inline-block" ｜ "none" ｜ "inline" */
  readonly styleDisplay = input<string>('block');

  /** flex 樣式物件 */
  flexStyle: any = { display: 'block' };

  /** 自定義 CSS 類名 */
  readonly jkClass = input<string>('');

  /** 是否可見 */
  readonly visible = model<boolean>(true);

  /** 是否禁用 */
  public readonly disabled = input(false);

  /** 是否唯讀 */
  readonly = model<boolean>(false);

  /** 是否必填 */
  readonly required = input<boolean>(false);

  /** 是否顯示清除按鈕 */
  public readonly showClearButton = input<boolean>(false);

  /** 開啟視窗載入選項陣列 */
  openwinLoadOpts: OpenWinLoadOption[] = [];

  /** 佔位符文字輸入 (對外綁定名為 placeholder) */
  readonly placeholderInput = input<string>('', { alias: 'placeholder' });

  /**
   * 取得佔位符文字，若未設定則使用標籤文字
   * @returns 佔位符文字
   */
  get placeholder(): string {
    const p = this.placeholderInput();
    if (p === '') {
      return this.label();
    }
    return p;
  }

  /** 組件寬度 */
  readonly width = model<string | number>('auto');

  /**
   * 取得寬度樣式物件
   * @returns 包含寬度 CSS 的物件
   */
  /*get widthStyle(): any {
    if ((this.width === undefined) || (this.width === null)) {
      this.width = 150;
    };
    let w = this.width as string + 'px';
    return {
      'width': w
    };
  }*/
  widthStyle: { [key: string]: string } = {}; // 定義為一個樣式物件

  /** 是否顯示標籤 */
  readonly displayLabel = input<boolean>(true);

  /** 標籤顯示模式 */
  readonly labelMode = input<LabelMode>('floating');

  /** 標籤文字 */
  readonly label = model<string>('');
  /**
   * @property {string} emojiLabel
   * @description 顯示在輸入欄位左側的 Emoji。
   */
  readonly emojiLabel = input('');

  /**
   * 檢查用戶是否已登入
   * @returns 登入狀態
   */
  public get isLogin(): boolean {
    if (this.login) return this.login.isLogin;
    else return false;
  }

  /**
   * 取得服務器 URL
   * @returns 服務器 URL
   */
  public get serverUrl(): string {

    if (!this.login) {
      alert('jkbae.serverUrl: login is null');
      return '';
    };
    return this.login.hostName;
  }

  /**
   * 取得用戶 ID
   * @returns 用戶 ID
   */
  public get uid(): string {
    if (!this.login) return '';
    return this.login.userid;
  }

  /**
   * 取得用戶名稱
   * @returns 用戶名稱
   */
  public get userName(): string {
    if (!this.login) return '';
    return this.login.name;
  }
  /** 登入服務 */
  login: LoginService; // =inject(LoginService);

  /** 頁面服務 */
  page: PageService = inject(PageService);

  /** HTTP 客戶端 */
  http: HttpClient = inject(HttpClient);

  /** ORM 服務 */
  orm: OrmService = inject(OrmService);

  /** 瀏覽器資料庫服務 */
  jkBDb: JkBDbService = inject(JkBDbService);

  /**
   * 建構函數
   * 初始化登入服務
   */
  constructor() {
    this.login = login;
    this.orm.init(this.http);

    effect(() => {
      this.flexStyle = { display: this.styleDisplay() };
    });
    effect(() => {
      const w = this.width();
      if (typeof w === 'number') {
        this.widthStyle = { 'width': `${w}px` };
      } else if (typeof w === 'string') {
        this.widthStyle = { 'width': w };
      } else {
        this.widthStyle = { 'width': 'auto' };
      }
    });
  }

  /**
   * 組件初始化
   */
  ngOnInit() {
  }
  /** 螢幕寬度 */
  get screenWidth(): number {
    return window.innerWidth - 40;
  }

  /** 螢幕高度 */
  get screenHeight(): number {
    return window.innerHeight;
  }

  /**
   * 視窗大小變更事件處理
   * 更新螢幕尺寸變數
   * @param $event 視窗大小變更事件
   */
  @HostListener('window:resize', ['$event'])
  onWindowResize($event?: any) {
  }

  /**
   * 取得網格寬度
   * @returns 目前的螢幕寬度
   */
  get myGridWidth(): number {
    return this.screenWidth;
  }

  /**
   * 顯示文本編輯對話框
   * @param content 文本內容
   * @param title 對話框標題
   * @returns 對話框關閉後的 Observable
   */
  doTextArea(
    content: string,
    title: string
  ) {
    let width = '80%';
    let height = '80%';

    const dialogRef = this.dialog.open(JkaboutComponent, {
      width: width,
      height: height,
      data: { title: title, content: content, result: true },
    });
    return dialogRef.afterClosed();
  };

  /**
   * 顯示 JSON 資料對話框
   * @param jsonObj JSON 物件
   * @returns 對話框關閉後的 Observable
   */
  doShowJson(
    //injector: Injector,
    jsonObj: any,
  ) {
    let width = '80%';
    let height = '80%';

    const dialogRef = this.dialog.open(JkaboutComponent, {
      width: width,
      height: height,
      data: { title: 'JSON', content: '', jsonObj: jsonObj, result: true },
    });
    return dialogRef.afterClosed();
  };

  /**
   * 同時顯示文本和 JSON 資料的對話框
   * @param title 對話框標題
   * @param content 文本內容
   * @param jsonObj JSON 物件
   * @returns 對話框關閉後的 Observable
   */
  doShowJsonAndTextArea(
    title: string,
    content: string,
    jsonObj: any
  ) {
    let width = '80%';
    let height = '80%';

    const dialogRef = this.dialog.open(JkaboutComponent, {
      width: width,
      height: height,
      data: { title: title, content: content, jsonObj: jsonObj, result: true },
    });
    return dialogRef.afterClosed();
  };

  /**
   * 顯示關於對話框
   * @returns 對話框關閉後的 Observable
   */
  doAbout() {
    let width = '80%';
    let height = '80%';
    const dialogRef = this.dialog.open(JkaboutComponent, {
      width: width,
      height: height,
      data: { title: '關於', content: '', result: true },
    });
    return dialogRef.afterClosed();
  };
  playAudio(result: ArrayBuffer): void {
    const audio = new Audio();
    const blob = new Blob([result], { type: 'audio/mpeg' });
    audio.src = URL.createObjectURL(blob);
    audio.play();
  }

}

